import { useEffect, useState } from "react";
import { Toast } from "flowbite-react";
import { HiCheck } from "react-icons/hi";

interface ValidToastProps {
  message?: string
  onClose?: () => void; // Optionnel : fonction appelée à la fermeture du toast
}

function ValidToast({ message = "Opération validée!", onClose }: ValidToastProps) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    // Définir un délai de 3 secondes pour cacher le toast
    const timer = setTimeout(() => {
      setVisible(false);
      if (onClose) onClose();
    }, 3000);

    // Nettoyage si le composant est démonté avant la fin du délai
    return () => clearTimeout(timer);
  }, [onClose]);

  // Si le toast n'est plus visible, ne rien rendre
  if (!visible) return null;

  return (
    <div className="fixed top-24 left-1/2 transform -translate-x-1/2 z-50 flex flex-col gap-4">
      <Toast>
        <div className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-green-100 text-green-500 dark:bg-green-800 dark:text-green-200">
          <HiCheck className="h-5 w-5" />
        </div>
        <div className="ml-3 text-sm font-normal">{message}</div>
      </Toast>

    </div>
  );
}
export default ValidToast;